import { seoCarCategoriesState } from './state';

export default (placeholder) => ({
  state: seoCarCategoriesState(placeholder),
  namespaced: true,
});
